import { gql } from '@apollo/client';

export const fetchCampaignTemplateId = gql`
  query getCampaignTemplate($campaignId: Long!) {
    campaign(id: $campaignId) {
      templateId
    }
  }
`;

export const fetchExperimentsForCampaignIdQuery = gql`
  query fetchNodeExperiments($campaignId: Long!) {
    campaign(id: $campaignId) {
      # Id is needed so the cache knows which campaign to merge the data with
      id
      experiments {
        name
        id
        state
        createdAt
      }
    }
  }
`;

export const validateMultiContent = gql`
  query validateTemplateContent($templateIds: [Long!]!) {
    validateMultiContent(templateIds: $templateIds) {
      errors {
        key
        value {
          __typename
        }
      }
    }
  }
`;

export const FetchPlacementByIdQuery = gql`
  query FetchPlacementById($id: Long!) {
    placement(id: $id) {
      payload {
        fields {
          placementName
        }
      }
    }
  }
`;
